'use client';

import { c as _c } from "react/compiler-runtime";
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
const DEMO_VIDEO_URL = typeof process.env.NEXT_PUBLIC_DEMO_VIDEO_URL === 'string' && process.env.NEXT_PUBLIC_DEMO_VIDEO_URL.length > 0 ? process.env.NEXT_PUBLIC_DEMO_VIDEO_URL : null;
export function DemoVideoModal(t0) {
  const $ = _c(14);
  const {
    open,
    onOpenChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Dialog.Overlay className="fixed inset-0 z-50 bg-black/80 transition-opacity" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onOpenChange) {
    t2 = () => onOpenChange(false);
    $[1] = onOpenChange;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== open) {
    t3 = <div className="relative aspect-video w-full overflow-hidden rounded-md bg-black">{DEMO_VIDEO_URL ? <iframe src={open ? DEMO_VIDEO_URL : undefined} title={"Set Screen \u2013 1 minute demo"} className="absolute inset-0 h-full w-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} /> : <div className="flex flex-col items-center justify-center gap-2 p-8 text-center text-white/80"><p className="text-lg font-medium">Video coming soon</p><p className="text-sm">We're putting together a short explainer. Check back soon or sign up to get notified.</p></div>}</div>;
    $[3] = open;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p id="demo-video-description" className="sr-only">{DEMO_VIDEO_URL ? "One-minute explainer showing an admin triggering a sequence on set." : "Demo video placeholder. Video coming soon."}</p>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Dialog.Close className="absolute right-4 top-4 rounded-full bg-black/60 p-2 text-white transition-colors hover:bg-black/80 focus:outline-none focus:ring-2 focus:ring-[var(--landing-accent-blue)]" aria-label="Close demo video"><X className="h-5 w-5" /></Dialog.Close>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t3) {
    t6 = <Dialog.Portal>{t1}<Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-[calc(100%-2rem)] max-w-3xl -translate-x-1/2 -translate-y-1/2 rounded-lg bg-black p-2 shadow-xl transition-opacity focus:outline-none" aria-describedby="demo-video-description" onEscapeKeyDown={t2}>{t3}{t4}{t5}</Dialog.Content></Dialog.Portal>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onOpenChange || $[11] !== open || $[12] !== t6) {
    t7 = <Dialog.Root open={open} onOpenChange={onOpenChange}>{t6}</Dialog.Root>;
    $[10] = onOpenChange;
    $[11] = open;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}